import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Collapse from '@material-ui/core/Collapse';
import Link from '@material-ui/core/Link';
import ExpandMore from '@material-ui/icons/ExpandMore';

// STYLES
import { Wrapper } from './styles';

function getControlsPosition(position) {
  switch (position) {
    case 'center':
      return 'text-center';
    case 'right':
      return 'text-right';
    default:
      return '';
  }
}

const ShowMoreText = props => {
  const {
    children,
    collapsedHeight,
    showMoreText,
    showLessText,
    openOnce,
    showExpandIcon,
    controlsAlignment,
    btnProps,
  } = props;
  const [t] = useTranslation();
  const [open, setOpen] = useState(false);
  const [childrenHeight, setChildrenHeight] = useState(0);
  const childrenRef = useRef(null);
  const defaultHeight = childrenHeight <= collapsedHeight ? childrenHeight : collapsedHeight;
  let showBtn = childrenHeight > collapsedHeight;

  if (openOnce && open) {
    showBtn = false;
  }

  useEffect(() => {
    if (childrenRef.current) {
      setChildrenHeight(childrenRef.current.offsetHeight);
    }
  }, [childrenRef]);

  const controlsPosition = getControlsPosition(controlsAlignment);

  return (
    <Wrapper className="show-more-text" controlsAlignment={controlsAlignment}>
      <Collapse in={open} collapsedSize={defaultHeight}>
        <div ref={childrenRef}>{children}</div>
      </Collapse>
      {showBtn && (
        <div className={clsx('show-more-text__controls', controlsPosition)}>
          <Link
            onClick={() => setOpen(!open)}
            component="button"
            color="textPrimary"
            {...btnProps}
            className={clsx('show-more-text__btn', btnProps.className || '')}
          >
            {open ? showLessText || t('buttons.showLess') : showMoreText || t('buttons.readMore')}
            {showExpandIcon && (
              <ExpandMore
                className={clsx('show-more-text__icon', open && 'show-more-text__icon--opened')}
              />
            )}
          </Link>
        </div>
      )}
    </Wrapper>
  );
};

ShowMoreText.defaultProps = {
  collapsedHeight: 90,
  showMoreText: '',
  showLessText: '',
  openOnce: false,
  showExpandIcon: true,
  controlsAlignment: 'left', // left | center | right
  btnProps: {},
};

ShowMoreText.propTypes = {
  collapsedHeight: PropTypes.number,
  children: PropTypes.element.isRequired,
  showMoreText: PropTypes.string,
  showLessText: PropTypes.string,
  openOnce: PropTypes.bool,
  showExpandIcon: PropTypes.bool,
  controlsAlignment: PropTypes.string,
  btnProps: PropTypes.object,
};

export default React.memo(ShowMoreText);
